import { Policy, PolicyBase, PolicyParticipant } from './policy';

export type HealthProductType = 'GENERIC' | 'DENTAL' | 'COMPENSATION';

export enum HealthFigureType {
  TI = 'TITULAR',
  HOLDER = 'TOMADOR',
  INSURED = 'ASEGURADO'
}

export enum HealthPaymentTypes {
  PAYER_TO = 'TO',
  PAYER_TI = 'TI',
  PAYMENT_MIX = 'MI'
}

export interface HealthListResponse {
  healthPolicies: PolicyHealth[];
}

export enum HealthGeneralConditionsError {
  DOCUMENT_NOT_FOUND = 'M#00603'
}
export interface PolicyHealth extends PolicyBase {
  policyBaseType: 'health';

  // INSURANCE COMMON ATTRS
  product: string;
  companyId: string;
  expirationDate: string;
  bank: string;
  iban: string;
  department: string;
  menu: string;
  // INSURANCE COMMON ATTRS

  // POLICY-HEALTH ATTRS
  productCode: string;
  figure: string;
  paymentMethod: string;
  entityCode: string;
  paymentFigure: string;
  comment: string;
  insureds: PolicyHealthInsured[];
  holder: PolicyHealthHolder;
  creditBank: string;
  creditIban: string;
  productType: string;
  paymentType: string;
  generalConditionsCode: string;
  participants?: PolicyParticipant[];
  // POLICY-HEALTH ATTRS
}

export interface PolicyHealthInsured {
  name: string;
  surname1: string;
  surname2: string;
  documentNumber: string;
  birthdate: string;
  cis: string;
  relationship: string;
  warranties: string[];
  medicalExpensesRefundEnabled: boolean;
  pharmaceuticalExpensesRefundEnabled: boolean;
  pharmaceuticalExpensesMinimumRequired: boolean;
  refunds?: Refund[];
  cessionOfPermits: boolean;
}

export function getFullName(insured: PolicyHealthInsured) {
  let fullName = '';
  if (insured.name) {
    fullName += insured.name + ' ';
  }
  if (insured.surname1) {
    fullName += insured.surname1 + ' ';
  }
  if (insured.surname2) {
    fullName += insured.surname2 + ' ';
  }
  if (fullName.length === 0) {
    return null;
  } else {
    return fullName.trim();
  }
}

export interface PolicyHealthHolder {
  name: string;
  documentNumber: string;
  residence: string;
  phone: string;
  birthdate: string;
}

export interface Refund {
  applicationDate: string;
  billAmount: number;
  billDate: string;
  communicationId: string;
  doctor: string;
  expedientId: string;
  status: string;
  insured?: PolicyHealthInsured;
  invoiceId?: string;
}

export interface MedicalGuide {
  medicalGuideCode: string;
  medicalGuideDescription: string;
}

export function isRefundEnabled(
  policy: PolicyHealth,
  allowedProducts: number[]
) {
  if (policy && allowedProducts) {
    return allowedProducts.some(r => +policy.productCode === r);
  }
  return false;
}

export const isHealthPolicy = (policy: Policy): policy is PolicyHealth =>
  policy?.policyBaseType === 'health';

export const isGeneralJudicialMutuality = policy =>
  isHealthPolicy(policy) && policy.productCode === '003';
